import { MessageSquare } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { GoogleReviewReplyDialog } from "./google-review-reply-dialog";

interface GoogleReviewReplyComposerProps {
  reviewId: string;
  reviewerName: string;
  existingReply: string | null;
  salonId: string;
}

export function GoogleReviewReplyComposer({
  reviewId,
  reviewerName,
  existingReply,
  salonId,
}: GoogleReviewReplyComposerProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const isEditing = Boolean(existingReply);

  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setDialogOpen(true)} className="px-2">
        <MessageSquare className="mr-1 h-3 w-3" />
        {isEditing ? "Edit reply" : "Reply"}
      </Button>
      <GoogleReviewReplyDialog
        reviewId={reviewId}
        reviewerName={reviewerName}
        existingReply={existingReply}
        salonId={salonId}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
}
